import { toast as sonnerToast } from "sonner";
import { AxiosError } from "axios";
export const useToast = ()=>{
    const success = (message, options)=>{
        sonnerToast.success(message, {
            duration: options?.duration ?? 4000,
            description: options?.description
        });
    };
    const error = (message, options)=>{
        sonnerToast.error(message, {
            duration: options?.duration ?? 5000,
            description: options?.description
        });
    };
    const info = (message, options)=>{
        sonnerToast.info(message, {
            duration: options?.duration ?? 4000,
            description: options?.description
        });
    };
    const warning = (message, options)=>{
        sonnerToast.warning(message, {
            duration: options?.duration ?? 4500,
            description: options?.description
        });
    };
    const promise = (promise, messages)=>{
        return sonnerToast.promise(promise, messages);
    };
    const handleApiError = (error, fallbackMessage = 'An error occurred')=>{
        if (error instanceof AxiosError) {
            const status = error.response?.status;
            const data = error.response?.data;
            if (status === 401) {
                sonnerToast.error('Authentication required', {
                    description: 'Please log in to continue'
                });
            } else if (status === 403) {
                sonnerToast.error('Permission denied', {
                    description: data?.message || 'You don\'t have permission to perform this action'
                });
            } else if (status === 404) {
                sonnerToast.error('Not found', {
                    description: data?.message || 'The requested resource was not found'
                });
            } else if (status === 409) {
                sonnerToast.error('Conflict', {
                    description: data?.message || 'This item already exists'
                });
            } else if (status === 429) {
                sonnerToast.error('Too many requests', {
                    description: 'Please wait a moment before trying again'
                });
            } else if (status && status >= 500) {
                sonnerToast.error('Server error', {
                    description: 'Something went wrong on our end. Please try again later.'
                });
            } else if (error.code === 'ERR_NETWORK') {
                sonnerToast.error('Network error', {
                    description: 'Please check your internet connection'
                });
            } else if (error.code === 'ECONNABORTED') {
                sonnerToast.error('Request timeout', {
                    description: 'The request took too long. Please try again.'
                });
            } else {
                sonnerToast.error(data?.message || fallbackMessage);
            }
        } else if (error instanceof Error) {
            sonnerToast.error(error.message || fallbackMessage);
        } else {
            sonnerToast.error(fallbackMessage);
        }
    };
    return {
        success,
        error,
        info,
        warning,
        promise,
        handleApiError,
        dismiss: sonnerToast.dismiss,
        dismissAll: ()=>sonnerToast.dismiss()
    };
};
